import axios from "axios";

// Auth uses httpOnly session cookies (withCredentials) — no tokens are ever kept in localStorage.
// localStorage is only used for non-sensitive UI state: wishlist/cart cache, recently viewed, promo code grabbed from a banner,
// early-access tokens (scoped, server-validated, expire with the season) and "already done" flags for forms.
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Subscriber early access: tokens from `/shop?seasonal=x&early=TOKEN` live in localStorage and ride along on every request.
export const EARLY_KEY = "hb_early_access";
export const earlyAccess = () => { try { return JSON.parse(localStorage.getItem(EARLY_KEY) || "{}"); } catch { return {}; } };
export const grantEarlyAccess = (slug, token) => localStorage.setItem(EARLY_KEY, JSON.stringify({ ...earlyAccess(), [slug]: token }));
api.interceptors.request.use((config) => {
  const pairs = Object.entries(earlyAccess());
  if (pairs.length) config.headers["X-Early-Access"] = pairs.map(([s, t]) => `${s}:${t}`).join(",");
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
